/**
 * Extracts a guid from an entity-href
 * (optionally, you may send in a guid and it will return the guid back out)
 */
export const getGuidFromHref = (guidOrHref: string) => guidOrHref.split('/').slice(-1)[0] as string;
